<template>
    <div class="font" v-if="show">
        <Modal v-model="show" footer-hide :mask-closable="false" width="800" :closable='false'>
            <h3>用户注册须知</h3>
            <h4>一、我们可能收集的信息我们根据合法、正当、必要的原则，仅收集实现平台功能所必要的信息。</h4>
            <p>1. 您在注册个人用户帐号时须至少向我们提供姓名、性别、电话号码、手机号码、电子邮箱、身份证号码、学位、职称、研究方向、供职单位等信息。</p>
            <p>2. 我们的部分服务可能需要您提供特定的个人敏感信息来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息。</p>
            <h4>二、我们可能如何使用收集到的信息</h4>
            <p>我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。</p>
            <p>1. 向您提供服务。例如，向您提供稿件处理流程与进度的查询服务、论文资源服务、稿件问题的及时沟通服务以及向您提供已发表论文的稿酬发放与样刊邮寄服务等。</p>
            <p>2. 产品开发和服务优化。例如，当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。</p>
            <p>3. 安全保障。例如，我们会将您的信息用于身份验证、安全防范、存档备份等用途，以保护您和我们的其他用户的合法权益。</p>
            <h4>三、我们可能共享的信息</h4>
            <p>我们会以高度严谨的态度对待您的信息，除以下情形外，我们收集的信息将仅用于本系统。未经您同意，我们绝对不会向任何第三方共享您的信息。</p>
            <p>我们可能为了实现以下目的，访问、使用、保留或披露您的信息：</p>
            <p>1. 遵循任何适用法律法规的要求、法院裁决或判决、或政府机关的强制性要求；</p>
            <p>2. 执行适用的服务条款（包括调查可能存在的违规情况）；</p>
            <p>3. 在法律法规要求或允许的范围内，保护我们的用户、我们或社会公众的合法权益免遭损害。</p>
            <h4>四、存储信息的地点</h4>
            <p>我们遵守法律法规的规定，将境内收集的用户个人信息存储于境内。</p>
            <h4>五、信息安全</h4>
            <p>我们非常重视信息安全，通过严格的安全保障措施努力保护您的信息不被未经授权的访问、使用或泄漏。但请您理解，由于技术的限制和互联网技术的飞速发展以及可能存在的各种恶意攻击手段，即便我们竭尽所能加强安全措施，也不可能始终保证信息的百分之百安全。请您了解，您使用我们的服务时所用的系统和通讯网络，有可能因超出我们控制能力之外的其他因素而出现安全问题。</p>
            <h4>六、未成年人保护</h4>
            <p>我们非常重视对未成年人信息的保护。根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用本系统的服务前，应事先取得您的家长或法定监护人的同意。</p>
            <h4>七、隐私政策的修订</h4>
            <p>我们可能对本隐私政策进行不时修订，该等修订构成本隐私政策的一部分。我们会在本系统页面上或通过其他我们认为合适的方式（包括向您发送电子邮件或以其他方式通知您）发布对本隐私政策所做的任何变更。若您继续使用我们的服务，即表示您同意受修订后的本隐私政策的约束。</p>
            <Button @click="sure" type="primary" class="buttons">已阅读并同意</Button>
        </Modal>
    </div>
</template>
<script>

export default {
    props: ["show"],
    data() {
        return{
            agree:false,
        }     
    },
    methods:{
        sure(){
            this.agree = true
            this.$emit("fun", this.agree);
        }
    }
}
</script>
<style scoped lang="less">
h3{
  font-size: 16px; 
  text-align: center; 
  font-weight: bold;
}
h4{
    font-weight: 600;
    text-indent: 2em;
}
p{
    text-indent: 2em;
}
/deep/ .ivu-modal-body{
    color:#333333;
    line-height:2;
    max-height: 700px;
    overflow-y: auto;
    padding: 60px;
}
.buttons{
    display:block;
    margin:0 auto;
    margin-top:20px
}

</style>
